export default {"src":"/_next/static/media/maharaja-trophy.15622fb8.svg","height":104,"width":126,"blurWidth":0,"blurHeight":0};